import * as internal from "stream";

export class TitleModel {
    title_id: number;
    title: string;
    title_description: string;

    constructor(title_id: number, title: string, title_description: string) {
        this.title_id = title_id;
        this.title = title;
        this.title_description = title_description;
    }
}